/** Format an elapsed millisecond span as `h:mm:ss` (or `m:ss` under an hour). */
export function fmtElapsed(ms: number): string {
  if (ms < 0) ms = 0;
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return h > 0 ? `${h}:${pad(m)}:${pad(sec)}` : `${m}:${pad(sec)}`;
}

/**
 * The runner's errorMessage carries a real diagnostic (result subtype,
 * stderr/output tails, gate output) which is often multi-line — the first
 * line is the headline; the rest goes into the Callout's mono detail block.
 */
export function splitError(message: string): { headline: string; detail?: string } {
  const nl = message.indexOf('\n');
  if (nl === -1) return { headline: message };
  const detail = message.slice(nl + 1).trim();
  return { headline: message.slice(0, nl), detail: detail || undefined };
}

/**
 * Detect whether a run error is a Claude subscription usage-limit hit.
 * Returns the reset time string if one was captured (e.g. "5pm"), or null if
 * the message doesn't match.
 */
export function parseSessionLimitError(message: string): { resetAt?: string } | null {
  if (!message.toLowerCase().includes('usage limit')) return null;
  const match = message.match(/resets at ([^\n.]+)/i);
  return { resetAt: match?.[1]?.trim() };
}
